import React from "react";
import Modal from 'react-bootstrap/Modal';
import STCModalBody from './STCModal.Body/STCModal.Body';
import STCModalFooter from "./STCModal.Footer/STCModal.Footer";
import STCModalHeader from "./STCModal.Header/STCModal.Header";
import STCModalTitle from "./STCModal.Title/STCModal.Title";


function STCModal(props){

    return(
        <Modal
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            bsPrefix={props.bsPrefix}
            size={props.size}
            fullscreen={props.fullscreen}
            centered={props.centered}
            backdrop={props.backdrop}
            backdropClassName={props.backdropClassName}
            keyboard={props.keyboard}
            scrollable={props.scrollable}
            animation={props.animation}
            dialogClassName={props.dialogClassName}
            contentClassName={props.contentClassName}
            dialogAs={props.dialogAs}
            autoFocus={props.autoFocus}
            enforceFocus={props.enforceFocus}
            restoreFocus={props.restoreFocus}
            show={props.show}
            onShow={props.onShow}
            onHide={props.onHide}
            onEscapeKeyDown={props.onEscapeKeyDown}
            onEnter={props.onEnter}
            onEntering={props.onEntering}
            onEntered={props.onEntered}
            onExit={props.onExit}
            onExiting={props.onExiting}
            onExited={props.onExited}
            manager={props.manager}
            // aria-labelledby={props.aria-labelledby}
            // aria-describedby={props.aria-describedby}
            // aria-label={props.aria-label}           
        >
            {props.children}
        </Modal>
    )
}

STCModal.Body = STCModalBody;
STCModal.Footer = STCModalFooter;
STCModal.Header = STCModalHeader;
STCModal.Title = STCModalTitle
export default STCModal;